import React from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '@/lib/i18n';
import { FacebookLogo, InstagramLogo } from '@phosphor-icons/react';

const LOGO = '/images/logo.jpg';

export default function Footer({ onApply }) {
  const { t } = useI18n();
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="bg-[#0A1128] text-white pt-24 md:pt-32 pb-10 relative overflow-hidden">
      <div className="absolute inset-0 grain opacity-30" />
      <div className="relative max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-4">
              <img src={LOGO} alt="De Melo Recruiting" className="w-14 h-14 object-cover border border-white/10" />
              <div>
                <div className="text-white text-lg font-medium">De Melo Recruiting</div>
                <div className="text-[10px] tracking-[0.3em] uppercase text-white/50">Freiburg · DE</div>
              </div>
            </div>
            <p className="mt-6 text-white/60 text-sm leading-relaxed max-w-md">{t.footer.tagline}</p>
            <div className="mt-4 font-display italic text-[#C5A059] text-base">Verbinden. Vermitteln. Weiterbringen.</div>
            <button
              onClick={onApply}
              data-testid="footer-apply-btn"
              className="mt-8 inline-flex items-center bg-[#C5A059] hover:bg-[#B38F4D] text-[#0A1128] px-6 py-3 text-[11px] font-semibold tracking-[0.22em] uppercase"
            >
              {t.nav.apply}
            </button>
          </div>

          <div className="md:col-span-3">
            <div className="eyebrow text-[#C5A059] mb-5">{t.footer.quick}</div>
            <ul className="space-y-3 text-white/70 text-sm">
              {['about','team','services','whyus','growth','contact'].map((id) => (
                <li key={id}>
                  <a href={`/#${id}`} data-testid={`footer-nav-${id}`} className="hover:text-[#C5A059] transition-colors">{t.nav[id]}</a>
                </li>
              ))}
            </ul>
            <div className="mt-6 eyebrow text-[#C5A059] mb-3">{t.footer.legal}</div>
            <ul className="space-y-3 text-white/70 text-sm">
              <li><Link to="/impressum" data-testid="footer-impressum" className="hover:text-[#C5A059] transition-colors">{t.footer.imprint}</Link></li>
              <li><Link to="/datenschutz" data-testid="footer-datenschutz" className="hover:text-[#C5A059] transition-colors">{t.footer.privacy}</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="eyebrow text-[#C5A059] mb-5">{t.contact.eyebrow}</div>
            <ul className="space-y-3 text-white/70 text-sm">
              <li><a href="tel:+4915208483930" className="hover:text-[#C5A059] transition-colors">+49 152 08483930</a></li>
              <li><a href="mailto:info@demelo-recruiting.de" className="hover:text-[#C5A059] transition-colors">info@demelo-recruiting.de</a></li>
              <li>Buchenstraße 14, 79108 Freiburg im Breisgau</li>
              <li className="text-white/60">Deutschland</li>
            </ul>
            <div className="mt-6">
              <div className="eyebrow text-[#C5A059] mb-3">{t.footer.social}</div>
              <div className="flex items-center gap-3">
                <a href="https://www.facebook.com/profile.php?id=61588441172876&locale=de_DE" target="_blank" rel="noopener noreferrer" data-testid="social-facebook" aria-label="Facebook" className="w-10 h-10 border border-white/20 hover:border-[#C5A059] hover:text-[#C5A059] flex items-center justify-center transition-colors">
                  <FacebookLogo size={18} weight="thin" />
                </a>
                <a href="https://www.instagram.com/demelo_recruiting?igsh=NGtidXNxb2x5emQ5&utm_source=qr" target="_blank" rel="noopener noreferrer" data-testid="social-instagram" aria-label="Instagram" className="w-10 h-10 border border-white/20 hover:border-[#C5A059] hover:text-[#C5A059] flex items-center justify-center transition-colors">
                  <InstagramLogo size={18} weight="thin" />
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-white/10 flex flex-col md:flex-row gap-4 items-center justify-between text-white/40 text-xs">
          <div>© {year} De Melo Recruiting. {t.footer.rights}</div>
          <div className="tracking-[0.25em] uppercase">Personalvermittlung • Subunternehmervermittlung • Auftragsvermittlung</div>
        </div>
      </div>
    </footer>
  );
}
